import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { Trans } from "@coworker/locales";
import styles from "./item-pieces.module.css";

export const ItemPieces = ({ pieces }: { pieces?: number }) => {
  if (pieces == null) return null;
  return (
    <div className={styles["item-pieces-container"]}>
      <b>
        <FixaText textStyle="Heading.XS">
          <Trans values={{ count: pieces }}>piecesCountString</Trans>
        </FixaText>
      </b>
    </div>
  );
};
